"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportSortDropdown = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Components_1 = require("../../Components");
var SelectableListItem_1 = require("../../Components/SelectableListItem");
exports.ReportSortDropdown = function (_a) {
    var setSortOptionSelected = _a.setSortOptionSelected, sortOptions = _a.sortOptions, sortOptionSelected = _a.sortOptionSelected;
    var _b = react_1.useState(null), sortAnchorEl = _b[0], setSortAnchorEl = _b[1];
    var _c = react_1.useState(false), isSortDropdownOpen = _c[0], setIsSortDropdownOpen = _c[1];
    var handleSortClick = function (event) {
        setSortAnchorEl(event.currentTarget);
        setIsSortDropdownOpen(true);
    };
    var onSortClose = function () {
        setSortAnchorEl(null);
        setIsSortDropdownOpen(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Components_1.IconButton, { size: "small", icon: "sort", onClick: handleSortClick, "data-testid": "reportsortdropdown-button", includeDropdownButton: true, toggled: isSortDropdownOpen }),
        react_1.default.createElement(Components_1.Dropdown, { anchorEl: sortAnchorEl, open: isSortDropdownOpen, onClose: onSortClose, "data-testid": "reportsortdropdown-dropdown" },
            react_1.default.createElement(StyledListContainer, null,
                react_1.default.createElement(SelectableListItem_1.SelectableListItem, { isSelected: sortOptionSelected === sortOptions.name, label: sortOptions.name, onClick: function () {
                        setSortOptionSelected(sortOptions.name);
                        onSortClose();
                    } }),
                react_1.default.createElement(SelectableListItem_1.SelectableListItem, { isSelected: sortOptionSelected === sortOptions.lastModified, label: sortOptions.lastModified, onClick: function () {
                        setSortOptionSelected(sortOptions.lastModified);
                        onSortClose();
                    } })))));
};
var StyledListContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: 0.8rem 0;\n"], ["\n  padding: 0.8rem 0;\n"])));
var templateObject_1;
